(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('channel', {
            parent: 'module',
            url: '/channel',
            data: {
                authorities: ['ROLE_CHANNEL']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/channel/channel.html',
                    controller: 'ChannelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('channelAdd', {
            parent: 'module',
            url: '/channelAdd',
            data: {
                authorities: ['ROLE_CHANNEL']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/channel/channel-add.html',
                    controller: 'ChannelAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('channelEdit', {
            parent: 'module',
            url: '/channelEdit/{id}',
            params:{page: null},
            data: {
                authorities: ['ROLE_CHANNEL']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/channel/channel-edit.html',
                    controller: 'ChannelEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Channels', function ($stateParams, Channels) {
                    return Channels.detail({id: $stateParams.id});
                }]
            }
        });
    }
})();
